import { twMerge } from "tailwind-merge";

type CardProps = {
  children: React.ReactNode;
  className: string;
}

export const Card = ({ children, className = "" }: CardProps) => {
  return (
    <div className={twMerge("bg-white shadow-md rounded-xl", className)}>
      {children}
    </div>
  );
};
